import { render } from "./Main.vue?vue&type=template&id=134b638c"
const script = {}
script.render = render

export default script